import React, { useState, useEffect, useRef } from "react";

import OkbajuApp from "../images/comp/okbaju-portfolio.webp";
import StoriseApp from "../images/comp/storise-app.webp";
import DutibookApp from "../images/comp/dutibook-portfolio.webp";
import VemottoApp from "../images/comp/vemotto-portfolio.webp";
import OkbajuWebsite from "../images/comp/portfolio-img.webp";
import StoriseWebsite from "../images/comp/portfolio-img-2.webp";
import JobsetWebsite from "../images/comp/portfolio-img-3.webp";

// ---- Portfolio Data ----
const portfolioItems = [
  {
    id: 1,
    type: "app",
    image: OkbajuApp,
    title: "OkBaju App",
    badge: "MOBILE APP",
    desc: "An all-in-one fashion e-commerce mobile app featuring secure login, intuitive browsing, and real-time order tracking.",
  },
  {
    id: 2,
    type: "app",
    image: StoriseApp,
    title: "Storise App",
    badge: "MOBILE APP",
    desc: "A social media platform with real-time messaging, photo sharing, and location-based content.",
  },
  {
    id: 3,
    type: "app",
    image: DutibookApp,
    title: "Dutibook App",
    badge: "MOBILE APP",
    desc: "Attendance & task management app with check-in/out, assignments, and productivity reports.",
  },
  {
    id: 4,
    type: "web",
    image: OkbajuWebsite,
    title: "Okbaju Website",
    badge: "WEB DEVELOPMENT",
    desc: "Responsive e-commerce website with filtering, cart, checkout, and admin dashboard.",
  },
  {
    id: 5,
    type: "web",
    image: StoriseWebsite,
    title: "Storise Website",
    badge: "WEB DEVELOPMENT",
    desc: "Corporate website for showcasing business services with responsive UI.",
  },
  {
    id: 6,
    type: "web",
    image: JobsetWebsite,
    title: "JobSet Website",
    badge: "WEB DEVELOPMENT",
    desc: "Job portal with job listings, resume upload, employer dashboards, and tracking.",
  },
];

const Portfolio_home = () => {
  const [filter, setFilter] = useState("all");
  const gridRef = useRef(null);

  const filtered =
    filter === "all"
      ? portfolioItems
      : portfolioItems.filter((item) => item.type === filter);

  // Animation effect when filter changes
  useEffect(() => {
    if (gridRef.current) {
      const cards = gridRef.current.querySelectorAll(".card");
      cards.forEach((card) => {
        card.style.animation = "none";
        void card.offsetHeight; // Force reflow
        card.style.animation = "tabani 1s forwards";
      });
    }
  }, [filter]);

  return (
    <section className="planning-section services-section">
      <div className="container">
        {/* Header */}
        <div className="row align-items-center justify-content-center">
          <div className="col-lg-9 mb-4 mb-lg-0 position-relative text-center">
            <span className="about-label">Portfolio</span>
            <h2 className="title">Web & App Portfolio</h2>
            <p className="sub-title text-black">
              At Hope Web Solutions, every project is a reflection of our
              commitment to quality and innovation.
            </p>
          </div>
        </div>

        {/* Tabs */}
        <div className="tabs">
          <button
            className={`tab-btn ${filter === "all" ? "active" : ""}`}
            onClick={() => setFilter("all")}
          >
            ALL
          </button>

          <button
            className={`tab-btn ${filter === "app" ? "active" : ""}`}
            onClick={() => setFilter("app")}
          >
            APP
          </button>

          <button
            className={`tab-btn ${filter === "web" ? "active" : ""}`}
            onClick={() => setFilter("web")}
          >
            WEB
          </button>
        </div>

        {/* Loop Grid */}
        <div className="grid" ref={gridRef}>
          {filtered.map((item) => (
            <div
              className={`card ${item.type === "app" ? "app-portfolio" : ""}`}
              data-type={item.type}
              key={item.id}
            >
              <img src={item.image} alt={item.title} />

              <div className="card-content">
                <h4 className="card-title">{item.title}</h4>
                <a className="card-badge">{item.badge}</a>

                <div className="card-desc">{item.desc}</div>
                <a className="btn btn-orange mt-3" href="#">
                  Know more
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portfolio_home;
